import React, { useContext } from 'react';
import { Lightswitch, Card, BlockHeader } from '@ems/client-design-system';
import { useConfigSelectors, useLanguageSelectors } from 'src/@app/reducers';
import { PageHeader } from 'src/components';
import { updateUserConfig } from 'src/@auth';
import { GlobalDispatchContext } from 'src/@app/providers/GlobalStateProvider';

export const ContentContainer = () => {
  const dispatcher = useContext(GlobalDispatchContext);
  // Config
  const configSelectors = useConfigSelectors();
  const portraitMode = configSelectors.getIfPortraitLayout();
  // Translation
  const languageSelectors = useLanguageSelectors();
  const {
    screens: {
      settings: { title },
    },
  } = languageSelectors.getLanguage();

  const updatePortraitMode = (isPortrait: boolean) => {
    updateUserConfig(dispatcher, {
      isPortrait,
    });
  };

  return (
    <>
      <PageHeader title={title} />
      <div className="layout_split settings_layout">
        <div className="layout_split--half">
          <div className="layout_content">
            <Card>
              <div>
                <BlockHeader title="Layout" />
                <div className="settings_switch">
                  <Lightswitch
                    enabled={portraitMode}
                    label="Portrait mode"
                    onClick={updatePortraitMode}
                  />
                </div>
              </div>
            </Card>
          </div>
        </div>
        <div className="layout_split--half">
          <div className="layout_content" />
        </div>
      </div>
    </>
  );
};
